// extracted by mini-css-extract-plugin
export var actions = "_29-0";
export var actionsContainer = "_29-7";
export var border = "_29-1";
export var childFullHeight = "_29-g";
export var collapse = "_29-2";
export var content = "_29-b";
export var contentChild = "_29-f";
export var fullscreen = "_29-d";
export var hasLeftRadius = "_29-l";
export var headerContainer = "_29-3";
export var headerRow = "_29-5";
export var hidePadding = "_29-c";
export var navCollapsedGap = "_29-m";
export var noScrollX = "_29-n";
export var noScrollY = "_29-o";
export var noTopPadding = "_29-j";
export var optOutTopPadding = "_29-e";
export var pageMain = "_29-k";
export var pageOuter = "_29-h";
export var pagePadding = "_29-8";
export var pageScroll = "_29-9";
export var profile = "_29-p";
export var profileContainer = "_29-q";
export var profileImage = "_29-r";
export var profileMain = "_29-s";
export var profileSubtitle = "_29-u";
export var profileTitle = "_29-t";
export var settingsSurface = "_29-a";
export var showLeftPadding = "_29-i";
export var tabsPortalSlot = "_29-6";
export var tabsWrapper = "_29-4";
export var title = "_29-v";